<template lang="pug">
section
    BaseHeader(
        :titulo='$t("mensagens.territorio.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )
    div(style='padding: 25px')
        form-territorio(
            @update='onForm',
            @validate='event => (validate.isForm = event)',
            :cultivo='cultivo',
            :fields='informacao'
        )
        informacao-especial(
            @add='adicionarLayer',
            @remover='removerMap',
            :layers='layersMaps',
            :geometria='geometryDesenho',
            :informacoes='informacoesEspeciais',
            :codigoLyra='informacao.codigoLyra'
        )
        .grid-cols-three
            enlace-persona(
                @update='setEnlace',
                @delete='setDelete',
                :papeis='papeis',
                :representantes='representantes',
                :options='params.representantes'
            )
            upload-arquivos(
                @add='setUpload',
                @delete='setDeleteArquivo',
                :items='params.arquivosTerritorio'
            )
            upload-evidencias(
                v-if='showUploadEvidencias',
                @add='setUploadEvidencia',
                @delete='setDeleteEvidencia',
                @before-delete='handleBeforeDeleteEvidencia',
                @update='setUpdateEvidencia',
                :items='params.evidencias'
            )
        modal-sucesso(:is-active='false')
        .flex.justify-content-end
            el-button(
                type='primary',
                style='margin-top: 15px',
                :disabled='validateForm',
                @click='handlerSubmit()'
            ) {{ $t('mensagens.territorio.territorioAr.salvar') }}
    ModalConsolidacao(
        :show='showModalConsolidarArea',
        @close='closeModal',
        @confirmaConsolidacao='confirmaConsolidacao'
    )
    ModalAvisoValidacaoRenspaAR(
        :show='showModalAvisoValidacaoRenspa',
        @close='closeModalValidacaoRenspa',
        @confirma='confirmaValidacaoRenspa'
    )
    ModalSelecionarLocalidadeOnccaAR(
        :show='mostrarModalSelecionarLocalidadeOnccaAR',
        :dados='dadosLocalidadeOncca',
        @voltar='mostrarModalSelecionarLocalidadeOnccaAR = false',
        @retornarDadosSelecionados='exibirDadosLocalidadeOncca',
        @realizarPesquisaOncca='realizarPesquisaOncca'
    )
    ModalConfirmarRemocaoEvidencia(
        :show='showModalConfirmarRemocaoEvidencia',
        @close='closeModalConfirmarRemocaoEvidencia',
        @confirma='confirmarRemocaoEvidencia'
    )
    div(v-if='dialogListaTerritoriosBaseVegaSelect')
        ModalSelecionarTerritoriosBaseVegaSobrepostosAR(
            v-if='dialogListaTerritoriosBaseVegaSelect',
            :show='dialogListaTerritoriosBaseVegaSelect',
            :territoriosBaseVega='territoriosBaseVegaComInterseccao',
            :geometriaTerritorio='layersMaps.length > 0 ? layersMaps[0].geometry : {}',
            :is-edit='!!$route.query.id',
            @voltar='dialogListaTerritoriosBaseVegaSelect = false',
            @salvar='salvarTerritorioBaseVegaEscolhido'
        )
</template>
<script>
import territorioService from '@/services/TerritorioService';
import CulturaService from '@/services/CulturaService';
import representanteService from '@/services/RepresentanteService';
import BaseHeader from '@/components/BaseHeader';
import FormTerritorio from '@/components/territorio/FormTerritorioAr.vue';
import InformacaoEspecial from '@/components/territorio/InformacaoEspecial.vue';
import EnlacePersona from '@/components/territorio/EnlacePersona.vue';
import UploadArquivos from '@/components/territorio/UploadArquivosAr.vue';
import UploadEvidencias from '@/components/territorio/UploadEvidenciasAr.vue';
import ModalConsolidacao from '@/components/territorio/ModalConsolidacaoAR.vue';
import ModalAvisoValidacaoRenspaAR from '@/components/territorio/ModalAvisoValidacaoRenspaAR.vue';
import ModalSucesso from '@/components/territorio/ModalSucesso.vue';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import LocalidadeService from '@/services/LocalidadeService';
import ModalSelecionarLocalidadeOnccaAR from '@/components/territorio/ModalSelecionarLocalidadeOnccaAR.vue';
import ModalConfirmarRemocaoEvidencia from '@/components/territorio/ModalConfirmarRemocaoEvidencia.vue';
import ModalSelecionarTerritoriosBaseVegaSobrepostosAR from '@/components/territorio/ModalSelecionarTerritoriosBaseVegaSobrepostosAR.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'CadastrarEditarTerritorioAR',
    components: {
        BaseHeader,
        FormTerritorio,
        InformacaoEspecial,
        EnlacePersona,
        UploadArquivos,
        UploadEvidencias,
        ModalConsolidacao,
        ModalSucesso,
        ModalAvisoValidacaoRenspaAR,
        ModalSelecionarLocalidadeOnccaAR,
        ModalConfirmarRemocaoEvidencia,
        ModalSelecionarTerritoriosBaseVegaSobrepostosAR
    },
    data() {
        return {
            informacao: {
                nome: null,
                provincia: null,
                renspa: null,
                informacoesAgricolas: [],
                idInterno: null,
                verificadoAr: null,
                codigoOncca: null
            },
            territorio: {},
            geometryDesenho: {},
            geometriaRenspaJaExistente: {},
            idLocalidadeOnccaRenspaJaExistente: null,
            selecionadoOnccaManualmenteRenspaJaExistente: null,
            params: {
                representantes: [],
                comercializacoes: [],
                arquivosTerritorio: [],
                evidencias: []
            },
            cultivo: [],
            papeis: [],
            representantes: [],
            layersMaps: [],
            validate: {
                isForm: false,
                isInformation: false,
                isEnlace: false,
                isUpload: true
            },
            informacoesEspeciais: {},
            showModalConsolidarArea: false,
            showModalAvisoValidacaoRenspa: false,
            usarGeometriaRenspaJaExistente: false,
            mostrarModalSelecionarLocalidadeOnccaAR: false,
            dadosLocalidadeOncca: [],
            dadosOnccaSelecionado: {},
            showModalConfirmarRemocaoEvidencia: false,
            indexEvidenciaParaRemover: null,
            dialogListaTerritoriosBaseVegaSelect: false,
            territoriosBaseVegaComInterseccao: [],
            idVegaAr: null,
            geometriaRemanescente: null
        };
    },
    created() {
        this.getCultura();
        this.getPapeis();
        this.getRepresentante();

        const id = this.$route.query.id;

        if (id) {
            this.getTerritorio(id);
        }
    },
    methods: {
        removerMap(index) {
            this.layersMaps.splice(index, 1);
        },
        async adicionarLayer(layer) {
            const indice = this.layersMaps.length;
            this.layersMaps.push(layer);

            await this.esperarGeometry(indice);

            this.postGeometria(this.layersMaps[indice].geometry, indice);
        },
        onForm(value) {
            this.informacao = { ...value };
        },
        setEnlace(value) {
            this.params.representantes.push(value);
        },
        setDelete(index) {
            this.params.representantes.splice(index, 1);
        },
        setDeleteArquivo(index) {
            this.params.arquivosTerritorio.splice(index, 1);
        },
        setUpload(value) {
            this.params.arquivosTerritorio.push(value);
        },
        setUploadEvidencia(value) {
            this.params.evidencias.push(value);
        },
        setDeleteEvidencia(index) {
            this.params.evidencias.splice(index, 1);
        },
        handleBeforeDeleteEvidencia({ index, item }) {
            const isEditMode = !!this.$route.query.id;
            if (isEditMode && item?.urlDownload) {
                this.indexEvidenciaParaRemover = index;
                this.showModalConfirmarRemocaoEvidencia = true;
            } else {
                this.setDeleteEvidencia(index);
            }
        },
        closeModalConfirmarRemocaoEvidencia() {
            this.showModalConfirmarRemocaoEvidencia = false;
            this.indexEvidenciaParaRemover = null;
        },
        confirmarRemocaoEvidencia() {
            if (this.indexEvidenciaParaRemover !== null) {
                this.setDeleteEvidencia(this.indexEvidenciaParaRemover);
                this.closeModalConfirmarRemocaoEvidencia();
            }
        },
        setUpdateEvidencia({ index, arquivo }) {
            this.$set(this.params.evidencias, index, arquivo);
        },
        async getTerritorio(id) {
            try {
                const { data } = await territorioService.findById(id);
                this.setMapGeometry({
                    geometria: data.geometria,
                    areaHa: data.areaHa
                });
                this.informacao.renspa = data.renspa;
                this.informacao.nome = data.nome;
                this.informacao.provincia = data.provincia;
                this.informacao.informacoesAgricolas =
                    data.informacaoAgricolaPY.map(item => {
                        return {
                            area: item.areaPlantada,
                            media: item.produtividade,
                            cultivo: this.cultivo.find(
                                ({ id }) => id === item.idCultura
                            )?.nomeTraduzido,
                            idCultura: item.idCultura
                        };
                    });
                this.informacao.idInterno = data.id_interno || '';

                this.params.representantes = data.representantes.map(item => {
                    return {
                        papel: {
                            nome: item.papelAR.nome,
                            id: item.papelAR.id
                        },
                        pessoa: {
                            nome: item.nomeRazaoSocial,
                            id: item.id,
                            documento: item.cpfCnpj
                        }
                    };
                });
                this.params.arquivosTerritorio = data.arquivosTerritorio.map(
                    item => {
                        return {
                            ...item,
                            name: item.nomeArquivo,
                            size: item.fileSize
                        };
                    }
                );

                this.params.evidencias = (data.evidenciasDeclaracaoJurada || []).map(
                    item => {
                        return {
                            ...item,
                            name: item.nomeArquivo,
                            size: item.fileSize,
                            tipoSoja: item.tipoSoja || '',
                            urlDownload: item.urlDownload || ''
                        };
                    }
                );

                this.informacao.verificadoAr = data.verificadoAr
                    ? this.$t('mensagens.comuns.sim')
                    : this.$t('mensagens.comuns.nao');

                this.informacao.codigoOncca = data.localidadeOncca?.codigoOncca;
                this.informacao.codigoLyra = data.codigoLyra || '';
                this.idVegaAr = data.idVegaAr || null;
                if (data.localidadeOncca?.id) {
                    this.dadosOnccaSelecionado = {
                        id: data.localidadeOncca.id,
                        inseridoManual: data.localidadeOncca.inseridoManual || false
                    };
                }
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        async handlerSubmit() {
            if (this.layersMaps.length > 1) {
                this.showModalConsolidarArea = true;
                return;
            }
            const renspa = this.informacao.renspa
                ? this.informacao.renspa.replace(/[^\d]+/g, '')
                : '';
            if (renspa) {
                const validacaoRenspa = await this.validacaoTerritorioRenspa(renspa);
                if (!validacaoRenspa) {
                    this.showModalAvisoValidacaoRenspa = true;
                    return;
                }
            }
            if (this.dadosOnccaSelecionado?.id) {
                await this.validaSobreposicaoBaseVegaAR();
            } else {
                this.buscaLocalidadeOnccaPorGeometria();
            }
        },
        async insertAr() {
            try {
                const { idInterno, ...informacao } = this.informacao;
                const params = {
                    ...informacao,
                    ...this.params,
                    renspa: this.informacao.renspa
                        ? this.informacao.renspa.replace(/[^\d]+/g, '')
                        : null,
                    id_interno: idInterno || null,
                    arquivosTerritorio: this.params.arquivosTerritorio,
                    geoJson: this.usarGeometriaRenspaJaExistente
                        ? this.geometriaRenspaJaExistente
                        : this.layersMaps[0].geometry,
                    representantes: this.params.representantes.map(item => {
                        return { idPapel: item.papel.id, id: item.pessoa.id };
                    }),
                    informacoesAgricolas:
                        this.informacao.informacoesAgricolas.map(item => {
                            return {
                                areaPlantada: item.area,
                                produtividade: item.media,
                                idCultura: item.idCultura
                            };
                        }),
                    idLocalidadeOncca: this.usarGeometriaRenspaJaExistente
                        ? this.idLocalidadeOnccaRenspaJaExistente
                        : this.dadosOnccaSelecionado.id,
                    selecionadoOnccaManualmente: this
                        .usarGeometriaRenspaJaExistente
                        ? this.selecionadoOnccaManualmenteRenspaJaExistente
                        : this.dadosOnccaSelecionado.inseridoManual,
                    idVegaAr: this.idVegaAr,
                    geometriaRemanescente: this.geometriaRemanescente
                        ? JSON.stringify(this.geometriaRemanescente)
                        : null
                };

                await territorioService.addArgentina(params);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.territorio.territorioAdicionadoSucesso'
                    )
                });
                this.$router.push({ name: 'TerritorioArgentina' });
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message.includes(
                        this.$t('mensagens.territorio.geometriaNaoValida')
                    )
                        ? this.$t(
                              'mensagens.territorio.erroCadastroTerritorioGeometriaInvalida'
                          )
                        : erro.response.data.message
                });
            }
        },
        async updateAr() {
            try {
                const { idInterno, ...informacao } = this.informacao;
                const params = {
                    ...informacao,
                    ...this.params,
                    renspa: this.informacao.renspa
                        ? this.informacao.renspa.replace(/[^\d]+/g, '')
                        : null,
                    id_interno: idInterno || null,
                    arquivosTerritorio: this.params.arquivosTerritorio,
                    geoJson: this.usarGeometriaRenspaJaExistente
                        ? this.geometriaRenspaJaExistente
                        : this.layersMaps[0].geometry,
                    representantes: this.params.representantes.map(item => {
                        return { idPapel: item.papel.id, id: item.pessoa.id };
                    }),
                    informacoesAgricolas:
                        this.informacao.informacoesAgricolas.map(item => {
                            return {
                                areaPlantada: item.area,
                                produtividade: item.media,
                                idCultura: item.idCultura
                            };
                        }),
                    idLocalidadeOncca: this.usarGeometriaRenspaJaExistente
                        ? this.idLocalidadeOnccaRenspaJaExistente
                        : this.dadosOnccaSelecionado.id,
                    selecionadoOnccaManualmente: this
                        .usarGeometriaRenspaJaExistente
                        ? this.selecionadoOnccaManualmenteRenspaJaExistente
                        : this.dadosOnccaSelecionado.inseridoManual,
                    idVegaAr: this.idVegaAr,
                    geometriaRemanescente: this.geometriaRemanescente
                        ? JSON.stringify(this.geometriaRemanescente)
                        : null
                };
                const id = this.$route.query.id;

                await territorioService.updateArgentina(params, id);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.territorio.territorioAdicionadoSucesso'
                    )
                });
                this.$router.push({ name: 'TerritorioArgentina' });
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message.includes(
                        this.$t('mensagens.territorio.geometriaNaoValida')
                    )
                        ? this.$t(
                              'mensagens.territorio.erroCadastroTerritorioGeometriaInvalida'
                          )
                        : erro.response.data.message
                });
            }
        },
        async preValicadaoAtualizacaoAr() {
            try {
                const params = {
                    renspa: this.informacao.renspa
                        ? this.informacao.renspa.replace(/[^\d]+/g, '')
                        : null,
                    geoJson: this.layersMaps[0].geometry
                };
                const id = this.$route.query.id;

                const req = await territorioService.preValicadaoAtualizacaoAr(
                    params,
                    id
                );

                if (req.data) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroPreValidacaoAtualizarTerritorio'
                        )
                    });
                }

                return req.data;
            } catch (erro) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroPreValidacaoAtualizarTerritorio'
                    )
                });
            }
        },
        async getCultura() {
            try {
                const { data } = await CulturaService.buscarCultura();
                this.cultivo = data;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        async getPapeis() {
            try {
                const { data } = await territorioService.listaPapeis();
                this.papeis = data;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        async getRepresentante() {
            try {
                const { data } =
                    await representanteService.listarRepresentante();
                this.representantes = data;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        setMapGeometry({ geometria, areaHa }) {
            const territorio = {
                type: 'AREA_CONSOLIDADA',
                codigo: 'AREA_CONSOLIDADA',
                area_ha: areaHa,
                geometry: geometria,
                identificadorGeometria: new Date().getTime()
            };

            this.mostrarTerritorioNoMapa(territorio);

            this.postGeometria(geometria, 0);
        },
        mostrarTerritorioNoMapa(territorio) {
            const layerTerritorio = {
                ...territorio,
                style: mapaEstilos.Geometria.imovelRuralCandidato,
                name: territorio.identificadorGeometria,
                geoJson: territorio.geometry,
                departamento: '',
                distrito: ''
            };

            this.layersMaps.push(layerTerritorio);
        },
        async postGeometria(geometria, index) {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadesPorGeometria(
                        geometria
                    );
                this.layersMaps[index].distrito = data.distritoNome;
                this.layersMaps[index].departamento = data.departamentoNome;
                this.geometryDesenho = geometria;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        esperarGeometry(index) {
            return new Promise(resolve => {
                const checar = () => {
                    if (this.layersMaps[index]?.geometry) {
                        resolve();
                    } else {
                        setTimeout(checar, 100);
                    }
                };
                checar();
            });
        },

        closeModal() {
            this.showModalConsolidarArea = false;
        },

        closeModalValidacaoRenspa() {
            this.showModalAvisoValidacaoRenspa = false;
        },

        confirmaConsolidacao() {
            let listGeometryToSend = {
                geometries: []
            };
            this.layersMaps.forEach(item => {
                listGeometryToSend.geometries.push({ ...item.geometry });
            });
            territorioService
                .consolidaTerritorio(listGeometryToSend)
                .then(response => {
                    if (response.status === 200) {
                        const identificadorGeometria = new Date().getTime();

                        const territorio = {
                            identificadorGeometria: identificadorGeometria,
                            type: response.data.tipo,
                            codigo: 'AREA_CONSOLIDADA',
                            area_ha: response.data.areaTotal,
                            geometry: response.data.geometry,
                            geoJson: response.data.geometry,
                            departamento: '',
                            distrito: ''
                        };

                        this.layersMaps = [];

                        this.layersMaps.push(territorio);

                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioConsolidadoComSucesso'
                            )
                        });

                        this.showModalConsolidarArea = false;

                        this.handlerSubmit();
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoConsolidarTerritorios'
                            )
                        });
                    }
                });
        },

        confirmaValidacaoRenspa() {
            this.usarGeometriaRenspaJaExistente = true;
            this.buscaLocalidadeOnccaPorGeometria();
        },

        async validacaoTerritorioRenspa(codigoRenspa) {
            const idTerritorio = this.$route.query.id
                ? this.$route.query.id
                : 0;

            try {
                const { data } =
                    await territorioService.validacaoTerritorioRenspa(
                        codigoRenspa,
                        idTerritorio
                    );

                if (data && data.renspaUtilizado) {
                    this.geometriaRenspaJaExistente = data.geometria;
                    this.idLocalidadeOnccaRenspaJaExistente =
                        data.localidadeOncca.id;
                    this.selecionadoOnccaManualmenteRenspaJaExistente =
                        data.localidadeOncca.inseridoManual;
                    return false;
                }

                return true;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        async buscaLocalidadeOnccaPorGeometria() {
            const geometria = this.usarGeometriaRenspaJaExistente
                ? this.geometriaRenspaJaExistente
                : this.layersMaps[0].geometry;

            try {
                const { data } = await LocalidadeService.buscarLocalidadeOncca({
                    geoJson: geometria
                });

                this.dadosLocalidadeOncca = data.itens;

                this.mostrarModalSelecionarLocalidadeOnccaAR = true;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        async buscaLocalidadeOnccaManualmente(filtro) {
            try {
                const { data } = await LocalidadeService.buscarLocalidadeOncca({
                    textoBusca: filtro
                });

                this.dadosLocalidadeOncca = data.itens;

                this.mostrarModalSelecionarLocalidadeOnccaAR = true;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        async realizarPesquisaOncca(filtro) {
            try {
                const { data } = await LocalidadeService.buscarLocalidadeOncca({
                    textoBusca: filtro
                });

                this.dadosLocalidadeOncca = data.itens;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        async exibirDadosLocalidadeOncca(dadosLocalidadeOnccaSelecionado) {
            this.dadosOnccaSelecionado = dadosLocalidadeOnccaSelecionado;

            if (this.dadosOnccaSelecionado) {
                await this.validaSobreposicaoBaseVegaAR();
            }
        },

        async validaSobreposicaoBaseVegaAR() {
            try {
                const geometria = this.usarGeometriaRenspaJaExistente
                    ? this.geometriaRenspaJaExistente
                    : this.layersMaps[0].geometry;

                const response = await territorioService.validaSobreposicaoBaseVegaAR(geometria);
                const { data } = response;

                this.geometriaRemanescente = data.geometriaRemanescente || null;

                if (response && !data?.possuiSobreposicao) {
                    await this.salvarTerritorioAr();
                    return;
                }

                this.territoriosBaseVegaComInterseccao = data.itens;
                this.dialogListaTerritoriosBaseVegaSelect = true;
            } catch (error) {
                this.$notify.error({
                    message: error?.response?.data?.message || error.message
                });
            }
        },

        salvarTerritorioBaseVegaEscolhido(territorioBaseVegaSelecionado) {
            this.idVegaAr = territorioBaseVegaSelecionado.idVega;
            this.dialogListaTerritoriosBaseVegaSelect = false;

            this.layersMaps = [];
            const territorio = {
                type: 'AREA_CONSOLIDADA',
                codigo: 'AREA_CONSOLIDADA',
                area_ha: territorioBaseVegaSelecionado.territorioArea,
                geometry: territorioBaseVegaSelecionado.geometria,
                identificadorGeometria: territorioBaseVegaSelecionado.cdTerritorio,
                geoJson: territorioBaseVegaSelecionado.geometria,
                departamento: '',
                distrito: ''
            };
            this.layersMaps.push(territorio);

            this.salvarTerritorioAr();
        },

        async salvarTerritorioAr() {
            if (this.$route.query.id) {
                const possuiImpedimentoAtualizarTerritorio =
                    await this.preValicadaoAtualizacaoAr();
                if (!possuiImpedimentoAtualizarTerritorio) {
                    this.updateAr();
                }
            } else {
                this.insertAr();
            }
        }
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        validateForm() {
            const validations = [
                this.validate.isForm,
                this.params.representantes.length > 0,
                this.layersMaps.length > 0
            ];

            return !Object.values(validations).every(item => item);
        },
        showUploadEvidencias() {
            const userAsRevenue = this.usuarioLogado.isArgentinaRevenda;
            if (userAsRevenue) {
                return true;
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
.grid-cols-three {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-top: 15px;
}

@media (max-width: 1400px) {
    .grid-cols-three {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
}
</style>
